import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set end date to 48 hours from now
    const endDate = new Date();
    endDate.setHours(endDate.getHours() + 48);
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const distance = endDate.getTime() - now;
      if (distance < 0) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      }
      return {
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const timeUnits = [{
    value: timeLeft.days,
    label: 'Días'
  }, {
    value: timeLeft.hours,
    label: 'Horas'
  }, {
    value: timeLeft.minutes,
    label: 'Minutos'
  }, {
    value: timeLeft.seconds,
    label: 'Segundos'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} className="inline-flex flex-col items-center gap-3" data-id="element-21">
      <div className="text-sm font-bold text-red-500 uppercase tracking-wider" data-id="element-22">
        ⏰ La oferta termina en:
      </div>
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-23">
        {timeUnits.map((unit, index) => <Fragment key={unit.label} data-id="element-24">
            <div className="flex flex-col items-center" data-id="element-25">
              <div className="bg-black border-2 border-orange-500 rounded-lg px-3 py-2 sm:px-4 sm:py-3 min-w-[60px] sm:min-w-[80px]" data-id="element-26">
                <div className="text-2xl sm:text-4xl font-extrabold text-orange-400 tabular-nums" data-id="element-27">
                  {String(unit.value).padStart(2, '0')}
                </div>
              </div>
              <div className="text-xs sm:text-sm font-medium text-gray-600 mt-1" data-id="element-28">
                {unit.label}
              </div>
            </div>
            {index < timeUnits.length - 1 && <div className="text-2xl sm:text-3xl font-bold text-orange-500 pb-6" data-id="element-29">
                :
              </div>}
          </Fragment>)}
      </div>
    </motion.div>;
}